import classNames from 'classnames';
import { PropsWithChildren } from 'react';
import { Button } from '../../../Button';
import { Backdrop, Modal } from '../../../overlay';
import { IsVisible } from '../../../utils';

interface ITableFiltersProps {
  cancelText?: string;
  handleClose: React.MouseEventHandler<HTMLButtonElement | HTMLDivElement>;
  handleFilter?: () => void;
  handleReset?: React.MouseEventHandler<HTMLButtonElement>;
  hasFilters?: boolean;
  isLoading?: boolean;
  open: boolean;
  submitText?: string;
  title?: string;
}

export function TableFilters({
  cancelText = 'Reset',
  children,
  handleClose,
  handleFilter,
  handleReset,
  hasFilters = false,
  isLoading = false,
  open,
  submitText = 'Filter',
  title = 'Filters',
}: PropsWithChildren<ITableFiltersProps>) {
  return (
    <Modal.Root
      backdrop={<Backdrop onClick={handleClose} open={open} />}
      open={open}
    >
      <Modal.Container className="max-h-full h-screen w-80 py-4 ml-auto">
        <Modal.Header handleClose={handleClose} title={title} />

        <Modal.Content className="min-h-full">
          <form className="min-h-full" onSubmit={handleFilter}>
            {children}

            <Modal.Actions
              className={classNames('mt-4', {
                'grid-cols-2 px-4': !!handleReset,
                'grid-cols-1 px-4': !handleReset,
              })}
            >
              <IsVisible when={!!handleReset}>
                <Button
                  className="text-secondary-two w-9/12"
                  design="transparent"
                  disabled={isLoading || !hasFilters}
                  onClick={handleReset}
                >
                  {cancelText}
                </Button>
              </IsVisible>
              <Button
                className="ml-auto w-9/12"
                design="secondary-dark"
                disabled={isLoading}
                isLoading={isLoading}
                type="submit"
              >
                {submitText}
              </Button>
            </Modal.Actions>
          </form>
        </Modal.Content>
      </Modal.Container>
    </Modal.Root>
  );
}
